module.exports = __webpack_public_path__ + "img/2021_1_17_holding_monsterr.4bbda79a.jpg";